// test2721
(2721 && 0);
